import { useState } from "react";

export default function Navbar({ menuItems = [], balance = null }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="topbar">
      <div className="logo">
        CHICKEN R<span className="egg" />AD
      </div>
      {balance && <span className="tb-bal">{balance}</span>}
      <button className="menu-btn" aria-label="Menu" onClick={() => setOpen((o) => !o)}>
        <span />
        <span />
        <span />
      </button>
      <nav className="menu" hidden={!open}>
        {menuItems.map((m) => (
          <button
            key={m.label}
            onClick={() => {
              m.onClick();
              setOpen(false);
            }}
          >
            {m.label}
          </button>
        ))}
      </nav>
    </header>
  );
}
